import { render } from "./loading-hello.vue?vue&type=template&id=53379de3"
const script = {}

import exportComponent from "D:\\vsts-agent\\_work\\68\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__